import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { CustomerAccountTypeService } from '../../../../services/customer-account-type.service';
import { CustomerAccountService } from '../../../../services/customer-account.service';
import Utils from '../../../../shared/utils';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-components-specialist-customer-account-read-only',
  templateUrl: './customer-account-read-only.component.html'
})
export class CustomerAccountReadOnlyComponent implements OnInit {
  @Input() public customerAccount: Boo.Objects.CustomerAccount;
  @Output() public customerAccountChange = new EventEmitter<Boo.Objects.CustomerAccount>();
  
  cmsAdminAccessTypeId = Boo.Objects.Enums.CustomerAccountTypes.CMSAdminAccess;
  warningMessages: string[] = [];

  private readonly editableAccountTypeIds = new Set<number>([
    Boo.Objects.Enums.CustomerAccountTypes.CMSAdminAccess,
  ]);

  utils = Utils;

  constructor(
    private customerAccountService: CustomerAccountService,
    private customerAccountTypeService: CustomerAccountTypeService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.warningMessages = this.getWarningsForAccount(this.customerAccount);
  }

  removePassword(): void {
    this.customerAccount.Password = '';
  }

  getPassword(): void {
    if (this.customerAccount.Password) {
      return;
    }

    this.customerAccountService.selectPasswordByAccountType(this.customerAccount.CustomerId, this.customerAccount.CustomerAccountTypeId)
      .subscribe(
        (password: string) => {
          this.customerAccount.Password = password;
        });
  }

  canEdit(accountTypeId: number): boolean {
    return this.editableAccountTypeIds.has(accountTypeId);
  }

  openEditCustomerAccountModal(content: TemplateRef<any>): void {
    this.modalService
      .open(content, { size: 'lg' })
      .result
      .finally(() => {
        this.customerAccountChange.emit({ ...this.customerAccount });
      });
  }

  get customerAccountTypeName(): string {
    return this.customerAccountTypeService.getName(this.customerAccount.CustomerAccountTypeId);
  }

  get customerAccountContainsData(): boolean {
    return (this.customerAccount.Url && this.customerAccount.Url.trim().length > 0) ||
      (this.customerAccount.Username && this.customerAccount.Username.trim().length > 0) ||
      (this.customerAccount.Note && this.customerAccount.Note.trim().length > 0);
  }

  get loginHref(): string {
    const needsProtocol = this.customerAccount.Url.toLowerCase().indexOf('http') !== 0 && this.customerAccount.Url.toLowerCase().indexOf('ftp') !== 0;
    return needsProtocol ? '//' + this.customerAccount.Url : this.customerAccount.Url;
  }

  private hasRequiredCmsCredentials(account: Boo.Objects.CustomerAccount): boolean {
    return !!account.Url?.trim() && !!account.Username?.trim();
  }

  private readonly warningRules: Record<number, AccountWarningRule[]> = {
    [this.cmsAdminAccessTypeId]: [
      {
        shouldWarn: account => !this.hasRequiredCmsCredentials(account),
        message:
          'The client or partner may have created a new admin user and sent an invitation to data@connectreporting.com. ' +
          'If so, please log in to the data@connectreporting.com email account to accept the invitation and then save the credentials here.'
      }
    ]
  };

  private getWarningsForAccount(account: Boo.Objects.CustomerAccount): string[] {
    const rules = this.warningRules[account.CustomerAccountTypeId] ?? [];

    return rules
      .filter(rule => rule.shouldWarn(account))
      .map(rule => rule.message);
  }
}

interface AccountWarningRule {
  shouldWarn: (account: Boo.Objects.CustomerAccount) => boolean;
  message: string;
}